import { createBrowserHistory } from 'history';
export default (rootUrl => {
  return createBrowserHistory({
    basename: rootUrl
  });
});